import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComponentModule} from '../component/component.module';
import {AdminResolver} from './admin-resolver';
import {AdminComponent} from './admin.component';
import {AdminRoutingModule} from './admin-routing.module';
import {ShipmentListComponent} from './shipment/shipment-list/shipment-list.component';
import {ShipmentDetailsComponent} from './shipment/shipment-details/shipment-details.component';
import {ShipmentResolver} from './shipment/shipment-details/shipment-resolver';
import {ShipmentListService} from './shipment/shipment-list.service';
import {AllShipmentListResolver} from './shipment/all-shipments/all-shipment-list-resolver';
import {AllShipmentsComponent} from './shipment/all-shipments/all-shipments.component';
import {DeviatedShipmentListResolver} from './shipment/deviated-shipment-list/deviated-shipment-list-resolver';
import {DeviatedShipmentListComponent} from './shipment/deviated-shipment-list/deviated-shipment-list.component';
import {ShipmentService} from './shipment/shipment.service';
import {UserTableComponent} from './user/user-table/user-table.component';
import {UserListComponent} from './user/user-list/user-list.component';
import {UserListResolver} from './user/user-list/user-list-resolver';
import {UserTypeNamePipe} from './user/user-type-name.pipe';
import {UserEditComponent} from './user/user-edit/user-edit.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DeviationDefinitionListComponent} from './deviation-definition/deviation-definition-list/deviation-definition-list.component';
import {DeviationDefinitionTableComponent} from './deviation-definition/deviation-definition-table/deviation-definition-table.component';
import {DeviationDefinitionListResolver} from './deviation-definition/deviation-definition-list/deviation-definition-list-resolver';
import {DeviationDefinitionEditComponent} from './deviation-definition/deviation-definition-edit/deviation-definition-edit.component';
import {DeviationTypeNamePipe} from './deviation-definition/deviation-type-name-pipe';
import {DeviationContextNamePipe} from './deviation-definition/deviation-context-name-pipe';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSortModule} from '@angular/material/sort';
import {ShipmentStatusNamePipe} from './shipment/shipment-status-name-pipe';
import {AssignOrderCarrierComponent} from './shipment/assign-carrier-dialog/assign-order-carrier.component';
import {AssignShipmentsComponent} from './shipment/assign-shipments/assign-shipments.component';
import {AssignShipmentsListResolver} from './shipment/assign-shipments/assign-shipments-list-resolver';
import {ShipmentItemComponent} from './shipment/shipment-item/shipment-item.component';
import {DeviationDefintionItemComponent} from './deviation-definition/deviation-defintion-item/deviation-defintion-item.component';
import {UserListItemComponent} from './user/user-list-item/user-list-item.component';
import {MatCardModule} from '@angular/material/card';
import {MatTableModule} from '@angular/material/table';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatMenuModule} from '@angular/material/menu';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {OrderStatusNamePipe} from './shipment/order-status-name-pipe';
import {MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate} from '@angular/material/datepicker';
import {DatePickerComponent} from '../component/date-picker/date-picker.component';
import {ShipmentListSettingsService} from './shipment/all-shipments/shipment-list-settings.service';
import {CarrierSearchInputComponent} from '../component/carrier-search-input/carrier-search-input.component';
import {ShipmentStatusFilterNamePipe} from './shipment/all-shipments/shipment-status-filter-name-pipe';
import {AssignOrdersComponent} from './order/assign-orders/assign-orders.component';
import {OrderTableComponent} from './order/order-table/order-table.component';
import {OrderAssignListResolver} from './order/assign-orders/order-assign-list-resolver.service';
import {AssignOrderUserComponent} from './order/assign-user-dialog/assign-order-user.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatExpansionModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSidenavModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSortModule,
    ReactiveFormsModule,
    ComponentModule,
    AdminRoutingModule,
    MatMenuModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatDateRangeInput,
    MatDatepickerToggle,
    MatDateRangePicker,
    FormsModule,
    MatStartDate,
    MatEndDate,
    DatePickerComponent,
    CarrierSearchInputComponent
  ],
  declarations: [
    AdminComponent,
    ShipmentListComponent,
    ShipmentDetailsComponent,
    AllShipmentsComponent,
    DeviatedShipmentListComponent,
    UserTableComponent,
    UserListComponent,
    UserTypeNamePipe,
    DeviationTypeNamePipe,
    DeviationContextNamePipe,
    UserEditComponent,
    DeviationDefinitionListComponent,
    DeviationDefinitionTableComponent,
    DeviationDefinitionEditComponent,
    ShipmentStatusNamePipe,
    OrderStatusNamePipe,
    AssignOrderCarrierComponent,
    AssignShipmentsComponent,
    ShipmentItemComponent,
    DeviationDefintionItemComponent,
    UserListItemComponent,
    ShipmentStatusFilterNamePipe,
    AssignOrdersComponent,
    OrderTableComponent,
    AssignOrderUserComponent
  ],
  providers: [
    AdminResolver,
    ShipmentResolver,
    AllShipmentListResolver,
    DeviatedShipmentListResolver,
    ShipmentListService,
    ShipmentService,
    UserListResolver,
    DeviationDefinitionListResolver,
    AssignShipmentsListResolver,
    ShipmentListSettingsService,
    OrderAssignListResolver
  ],
  exports: [
    OrderStatusNamePipe,
    ShipmentStatusNamePipe,
    ShipmentStatusFilterNamePipe
  ]
})
export class AdminModule {
}
